import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceocean/vesselarrival'
import pathMap from 'src/paths/pathMap'

class AceOcnVesselArrivalRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_ARRIVAL_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_ARRIVAL_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_ARRIVAL_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_ARRIVAL_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceOcnVesselArrivalRoute
